jQuery(document).ready(function($) {

    window.$ = jQuery;

    var smartObject = null;
    var smartObjectReady = false;
    var smartObjectLoaded = false;
    
    /**
     * GIS configuration
     */
    var dojoConfig = {
        async: true,
        transparentColor: [255, 255, 255],
        baseUrl: 'https://gis.gavle.se/pubs/smart/dist',
        packages: [
            'dojox',
            'dijit',
            'dgrid',
            'xstyle',
            'put-selector',
            'esri',
            {
                name: 'moment',
                location: 'moment',
                main: 'moment',
                trees: [
                    [".", ".", /(\/\.)|(~$)|(test|txt|src|min|templates)/]
                ]
            },
            'dojo',
            'lib',
            'smart',
            'jquery'
        ],
        cacheBust: true
    };


    $('[data-name="gk-places-icon"]').click(function () {

        if(!smartObjectLoaded) {

            $('body').prepend(gisDOM());
            
            var script = document.createElement('script');
            script.type = 'text/javascript'; 
            script.async = true;
            script.src = 'https://gis.gavle.se/pubs/smart/dist/dojo/dojo.js';
            script.onload = function () {     

                $('<img src="/wp-admin/images/loading.gif" style="margin:32px auto;" class="gis-loading" />').insertAfter(".acf-field-59c20d66dc97e > :last-child");

                require(['dojo/ready', 'dojo/request/script', "esri/urlUtils", 'smart/app/SMART'], function (ready, script, urlUtils) { 	 
                    
                    var urlobject = urlUtils.urlToObject(document.location.href);
                    
                    script.get("https://gis.gavle.se/pubs/smartProfileService/SmartMapService.svc/GetMap/standard-gavle-se", {
                        jsonp: "callback"
                    }).then(function (profile, topic) {

                        require(['smart/app/InitApp'], function (smart) { 
                            // Startup
                            smart.startup(profile, urlobject, null, true);
                            
                            gisToggleIcons();
                        });
                    }); 
                });  
            };

            var location = document.getElementsByTagName('script')[0]; 
            location.parentNode.insertBefore(script, location);
            smartObjectLoaded = true;
        }
        else {
            gisToggleIcons();
        }

    });

    $(document).on('click', '.smart-symbol-list > li', function () { 
        $('[data-name="gk-places-icon"] input').val($(this).data('renderer-id'));
    });

    $(document).on('click', '.report-user-row', function () {
        $(this).parent().find('.gk-report-user-hidden').toggleClass('hidden');
    });

    function gisToggleIcons() {

        console.log($('.smart-symbol-list'));

        if($('.smart-symbol-list').length) {
            
            if($('.smart-symbol-list').is(':visible')) {
                $('.smart-symbol-list').hide();
            }
            else {
                $('.smart-symbol-list').show();
            }
        }
        else {
            SMART.getRendererCollection({
                type:"html"
            }).then(function(renderers){
                $('.gis-loading').remove();
                $(renderers).insertAfter("[data-name='gk-places-icon'] > :last-child");
                
            });
        }
    }

    function gisDOM() {
         return '' +
            '<style>.smart-symbol-list li { height:32px; width:100%; } .smart-symbol-list * { cursor:hand; height: 32px; width: 32px; float: left; margin-right: 16px; } </style><div id="smart-container" style="display:none;">' +
                '<div id="smart-loading-overlay">' +
                    '<div id="smart-loading-text">' +
                        '<img src="https://gis.gavle.se/pubs/smart/images/loader_app.gif" />' +
                        '<span id="smart-loading-name" style="margin-left:10px;">Laddar karta...</span>' +
                    '</div>' +
                '</div>' +
                '<div id="smart-map-container" data-dojo-type="dijit/layout/BorderContainer" data-dojo-props="design:\'sidebar\', gutters: false, liveSplitters:true">' +
                    '<div id="smart-header-container" data-dojo-type="dijit/layout/BorderContainer" data-dojo-props="design:\'headline\', gutters: false, liveSplitters:false, region: \'top\'"></div>' +
                    '<div id="map" data-dojo-type="dijit/layout/ContentPane" data-dojo-props="splitter:true, gutters: false, region:\'center\'" class="map"></div>' +
                '</div>' +
            '</div>';
    }

    var updateQueryStringParam = function (key, value) {

        var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            urlHashString = document.location.hash,
            newParam = key + '=' + value,
            params = '?' + newParam;
    
        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            keyRegex = new RegExp('([\?&])' + key + '[^&]*');
    
            // If param exists already, update it
            if (urlQueryString.match(keyRegex) !== null) {
                params = urlQueryString.replace(keyRegex, "$1" + newParam);
            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }
        ;
        window.history.replaceState({}, "", baseUrl + urlHashString + params);
    };

        $('.gk-search-prio input').on('change', function () { 
        var params = ''; 
        params = $(this).val(); 
        updateQueryStringParam('search', params); 
    }); 
    
});